module.exports = __webpack_public_path__ + "img/pay.351617a3.png";